function constant(value) {
    return function () {
        return value;
    };
}

export { constant as default };
